// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import FlatRoofsPage from "../pages/FlatRoofs/FlatRoofs";
const __wvcRoutePaths = ["/FlatRoofsPage", "/flat-roofs"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["chimneys", "chimneyspage", "fascias-soffits", "fasciassoffitspage", "flat-roofs", "flatroofspage", "gallery", "gallerypage", "get-in-touch", "getintouchpage", "guttering", "gutteringpage", "home", "homepage", "lead-work", "leadworkpage", "new-roofs", "newroofspage", "our-craft", "ourcraftpage", "post", "privacy-policy", "privacypolicypage", "repointing", "repointingservicespage", "roof-cleaning", "roofcleaningpage", "roofing-services", "roofingservicespage", "services-hub", "serviceshubpage", "terms-of-service", "termsofservicepage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<FlatRoofsPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<FlatRoofsPage />} />
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
